<ng-container *ngIf="readyLog">
    <ng-container>
        <app-table [columns]="headerTableLogs" [dataSource]="logErrorList" [hasButton]="false"
            [actionsTemplate]="actionsButtonsLogs"></app-table>

        <ng-template #actionsButtonsLogs let-uid="uid">

        </ng-template>
    </ng-container>
</ng-container>
<ng-container *ngIf="!readyLog">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>